<div class="sidebar" [class.-active]="active" (click)="toggleMenu()">
  <div class="wrapper" (click)="$event.stopImmediatePropagation();">
      <div class="header" [attr.data-test]="'divHeaderIcon'">
          <img src="assets/images/icone-unico.svg" alt="unico | analysis" width="40">
          <button (click)="toggleMenu()" [attr.data-test]="'btnToggleMenu'">
              <img src="assets/images/ico-prev.svg" alt="">
          </button>
      </div> 
      <div class="-container" [attr.data-test]="'divSidebarMenu'">
          <ul class="-menu" [attr.data-test]="'ulMenu'">
              <li class="-items"><a class="menu-link fila" [routerLink]="['/superlist']" (click)="toggleMenu()" [attr.data-test]="'linkSuperlist'" *ngxPermissionsOnly="['super_admin']">Fila de Análise</a></li>
              <li class="-items"><a class="menu-link auditoria" [routerLink]="['/audit']" (click)="toggleMenu()" [attr.data-test]="'linkAudit'" *ngxPermissionsOnly="['auditor']">Auditoria</a></li>
              <li class="-items"><a class="menu-link relatorios" [routerLink]="['/reports']" (click)="toggleMenu()" [attr.data-test]="'linkReports'" *ngxPermissionsOnly="['report']">Relatórios</a></li>
              <li class="-items"><a class="menu-link gerenciador" [routerLink]="['/management']" (click)="toggleMenu()" [attr.data-test]="'linkManagement'" *ngxPermissionsOnly="['manager']">Gerenciador</a></li>
              <li class="-items"><a class="menu-link sair" [routerLink]="['/']" (click)="logout()" [attr.data-test]="'linkLogout'">Sair</a></li>
          </ul>
      </div>
  </div>
</div>